import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import * as service from "@/methods/service";

// @ts-ignore
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import * as catalog from "@/apis/catalog";

@Component({
	components: {
		VueSlickCarousel
	}
})
export default class BinRentalPricingComponent extends Vue {

	sliderSettings = {
		"centerMode": true,
		"dots": false,
		'arrows': true,
		"infinite": false,
		"speed": 500,
		"slidesToShow": 4,
		"slidesToScroll": 1,
		"centerPadding": "20px",
		"responsive": [
			{
				"breakpoint": 1263,
				"settings": {
					"slidesToShow": 3,
					"slidesToScroll": 1,
					"infinite": true,
				}
			},
			{
				"breakpoint": 990,
				"settings": {
					"slidesToShow": 2,
					"slidesToScroll": 1,
					"infinite": true,
				}
			},
			{
				"breakpoint": 680,
				"settings": {
					'arrows': true,
					"slidesToShow": 1,
					"slidesToScroll": 1
				}
			}
		]
	}


	isOpenCard = false
	error = ''

	pageWidth: number = 1920;

	priceItems = []

	openCard() {
		this.isOpenCard = true
	}

	mounted() {
		this.pageWidth = window.screen.width;
		window.addEventListener('resize', (x) => {
			this.pageWidth = window.screen.width
		})
	}

	async created() {
		const requestData = {
			securityToken: this.$store.getters.token,
			zipCode: this.$store.getters.postcode,
		};
		this.$store.commit('setOverlay', true)
		const priceItemsFromServer = await catalog.getCatalogList(requestData)

		const { data } = priceItemsFromServer;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			this.error = errMsg
			throw new Error(errMsg);
		} else {
			if (data.PriceItems && data.PriceItems.length !== 0) {
				this.priceItems = data.PriceItems.filter((item: any) => ((item.serviceID == 173 || item.serviceID == 174 ||
					item.serviceID == 175 || item.serviceID == 176 || item.serviceID == 182) && item.isActive === true))
				this.$store.commit('setOverlay', false)
			}
			else {
				this.error = 'can not find priceItems'
				throw new Error('can not find priceItems');
			}
		}

	}

	chooseCard(sizeBox: string) {
		this.$store.dispatch('showRemaning');
		if (sizeBox === 'mini') {
			const serviceID = 173
			if(this.$store.getters.serviceID && +this.$store.getters.serviceID !== +serviceID){
				console.log('tr')
				if(sessionStorage.getItem('endDate') && sessionStorage.getItem('startDate')){
					sessionStorage.removeItem('endDate')
					sessionStorage.removeItem('startDate')
				}
			}
			this.$store.commit('updateServiceID', serviceID)
			this.$store.commit('setSecondStepComplited');
			this.$router.push({ name: 'firstStep', params: {} })
		}
		if (sizeBox === 'medium') {
			const serviceID = 175
			if(this.$store.getters.serviceID && +this.$store.getters.serviceID !== +serviceID){
				console.log('tr')
				if(sessionStorage.getItem('endDate') && sessionStorage.getItem('startDate')){
					sessionStorage.removeItem('endDate')
					sessionStorage.removeItem('startDate')
				}
			}
			this.$store.commit('updateServiceID', serviceID)
			this.$store.commit('setSecondStepComplited');
			this.$router.push({ name: 'firstStep', params: {} })
		}
		if (sizeBox === 'small') {
			const serviceID = 174
			if(this.$store.getters.serviceID && +this.$store.getters.serviceID !== +serviceID){
				console.log('tr')
				if(sessionStorage.getItem('endDate') && sessionStorage.getItem('startDate')){
					sessionStorage.removeItem('endDate')
					sessionStorage.removeItem('startDate')
				}
			}
			this.$store.commit('updateServiceID', serviceID)
			this.$store.commit('setSecondStepComplited');
			this.$router.push({ name: 'firstStep', params: {} })
		}
		if (sizeBox === 'large') {
			const serviceID = 176
			if(this.$store.getters.serviceID && +this.$store.getters.serviceID !== +serviceID){
				console.log('tr')
				if(sessionStorage.getItem('endDate') && sessionStorage.getItem('startDate')){
					sessionStorage.removeItem('endDate')
					sessionStorage.removeItem('startDate')
				}
			}
			this.$store.commit('updateServiceID', serviceID)
			this.$store.commit('setSecondStepComplited');
			this.$router.push({ name: 'firstStep', params: {} })
		}
	}


}
